<template>
<!--答题-->
  <div id="examtest">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      <b>{{number}}</b>/{{totalNum}}
      <div class="right" style="display: none">
        <a @click="submitOpen()"><img src="../../assets/icon/examtest_icon_jj.png" alt="">交卷</a>
        <a @click="gotoCard"><img src="../../assets/icon/examtest_icon_dtk.png" alt="">答题卡</a>
        <a @click="toCollect"><img :src="isCollected ? require('../../assets/icon/examtest_icon_sc1.png') : require('../../assets/icon/examtest_icon_sc0.png')" alt="">收藏</a>
      </div>
    </h2>
    <v-touch v-on:swipeleft="getNext" v-on:swiperight="getPrev" tag="div" class="v-touch">
      <h3 class="type">单选题</h3>
      <!--
      <div class="question">
        <div class="title">
          下列关于幼儿全面发展的说法错误的是（ ）
        </div>
        <div class="choice">
          <label>
            <dl>
              <dt><input type="radio" name="choice_answer"><i>A</i></dt>
              <dd>智力的发展，道德品质、意志的培养在很大程度上取决于健康状况</dd>
            </dl>
          </label>
          <label>
            <dl>
              <dt><input type="radio" name="choice_answer"><i>B</i></dt>
              <dd>美育有助于发展幼儿注意、观察、记忆、思维、想象等认知能力</dd>
            </dl>
          </label>
          <label>
            <dl>
              <dt><input type="radio" name="choice_answer"><i>C</i></dt>
              <dd>体育的作用最小</dd>
            </dl>
          </label>
          <label>
            <dl>
              <dt><input type="radio" name="choice_answer"><i>D</i></dt>
              <dd>美育能协调体、智、德育的发展，是体、智、德育的催化剂</dd>
            </dl>
          </label>
        </div>
      </div>
      -->
      <div class="question">
        <div class="title" v-if="testData.head && testData.head.code === 'hot_details_img'"><img src="item.img" v-for="(item, index) in testData.head.img" :key="index"></div>
        <div class="title" v-else-if="testData.head" v-text="testData.head.img"></div>
        <div class="title" v-if="testData.question && testData.question.code === 'hot_details_img'"><img src="item.img" v-for="(item, index) in testData.question.img" :key="index"></div>
        <div class="title" v-else-if="testData.question" v-text="testData.question.img"></div>
        <div class="choice" v-if="typeId === 1 || typeId === 2">
          <label v-for="(item, index) in testData.options" :key="index">
            <dl>
              <dt><input type="radio" name="choice_answer" v-model="optionsId" :value="item.options_id"><i>{{item.opt_index}}</i></dt>
              <dd>{{item.title}}</dd>
            </dl>
          </label>
        </div>
        <div class="short" v-else>
          <textarea v-model="textAnswer" id="" cols="30" rows="10"></textarea>
        </div>
      </div>
      <hr>
      <div class="analysis">
        <h4 @click="showAnswer">答题解析</h4>
        <div v-if="testData.analyze" v-text="testData.analyze.img" v-show="answerShow"></div>
      </div>
      <div class="bottom">
        <a @click="getPrev" class="prev"><img src="../../assets/icon/examtest_icon_prev.png"></a>
        <a @click="submitOpen"><img src="../../assets/icon/examtest_icon_submit.png">交卷</a>
        <a @click="gotoCard"><img src="../../assets/icon/examtest_icon_card.png">答题卡</a>
        <a @click="toCollect"><img :src="isCollected ? require('../../assets/icon/examtest_icon_collect1.png') : require('../../assets/icon/examtest_icon_collect0.png')">收藏</a>
        <a @click="getNext" class="next"><img src="../../assets/icon/examtest_icon_next.png"></a>
      </div>
      <div class="fix-valid"></div>
      <exam-submit v-if="submitShow" :recordId="this.recordId" :recordType="this.number >= this.totalNum ? 2 : 1" v-on:listenSubmit="submitClose()"></exam-submit>
    </v-touch>
    <i-login @listenShow="showLogin" v-show="loginShow"></i-login>
  </div>
</template>

<script>
import ExamSubmit from './ExamSubmit.vue'
import iLogin from '../share/popup/login/iLogin'
export default {
  name: 'ExamTest',
  data () {
    return {
      examId: this.$route.query.exam_id ? this.$route.query.exam_id : 2,
      chapterId: this.$route.query.chapter_id ? this.$route.query.chapter_id : 0,
      number: this.$route.query.number ? this.$route.query.number : 1,
      recordId: this.$route.query.record_id ? this.$route.query.record_id : 0,
      testData: {},
      submitShow: false,
      answerShow: false,
      totalNum: 1,
      questionId: 0,
      optionsId: 0,
      typeId: 1,
      isCollected: 0, // 0 未关注  1 已关注
      textAnswer: '',
      loginShow: false
    }
  },
  components: {
    ExamSubmit,
    iLogin
  },
  mounted () {
    this.getFirst()
    this.gotoLogin()
  },
  methods: {
    getExamTest () {
      let data = {
        exam_id: this.examId,
        chapter_id: this.chapterId,
        number: this.number,
        record_id: this.recordId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_topic_first',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.testData = res.data.data
            this.totalNum = res.data.data.count
            this.questionId = res.data.data.question_id
            this.isCollected = res.data.data.is_collection
            this.typeId = res.data.data.type_id
            let _this = this
            res.data.data.options.forEach(function (e) {
              if (e.write_answer === 1) {
                _this.optionsId = e.options_id
              }
            })
            if (res.data.data.write_answer) {
              this.textAnswer = res.data.data.write_answer
            }
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'ExamTest'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    sendAnswer () {
      let data = {
        question_id: this.questionId,
        record_id: this.recordId,
        answer: (this.typeId === 1 || this.typeId === 2) ? this.optionsId : this.textAnswer,
        used_time: 5,
        number: this.number
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_question_answer',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.testData = res.data.data
            this.totalNum = res.data.data.count
            this.recordId = res.data.data.record_id
            this.getExamTest()
            this.optionsId = 0
            this.textAnswer = ''
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    submitOpen () {
      this.submitShow = true
    },
    submitClose () {
      this.submitShow = false
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    // 获得上一题的信息并保存答案
    getPrev () {
      if (this.number <= 1) {
        alert('这是第一题，前面没有了')
        return false
      }
      this.number = parseInt(this.number) - 1
      // this.getExamTest()
      this.sendAnswer()
      this.answerShow = false
    },
    // 获取下一题信息并保存答案
    getNext () {
      if (this.optionsId === 0 && (this.typeId === 1 || this.typeId === 2)) {
        alert('请先选择一个答案')
        return false
      }
      if (this.number >= this.totalNum) {
        alert('这是最后一题，请点击交卷')
        return false
      }
      this.number = parseInt(this.number) + 1
      this.sendAnswer()
      this.answerShow = false
    },
    showAnswer () {
      this.answerShow = true
    },
    gotoCard () {
      if (this.optionsId) {
        this.sendAnswer()
      } else if (this.textAnswer) {
        this.sendAnswer()
      }
      this.$router.push({name: 'ExamCard', query: {exam_id: this.examId, chapter_id: this.chapterId, record_id: this.recordId, record_type: this.number >= this.totalNum ? 2 : 1, number: this.number}})
    },
    // 收藏
    toCollect () {
      let data = {
        question_id: this.questionId,
        collection_type: this.isCollected // 0 添加收藏  1 取消收藏
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_question_collection',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.isCollected = this.isCollected ? 0 : 1
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 读取初始答题记录
    getRecord () {
      let data = {
        exam_id: this.examId,
        chapter_id: this.chapterId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_record_first',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            if (res.data.data.number) {
              this.number = res.data.data.number
            }
            if (res.data.data.record_id) {
              this.recordId = res.data.data.record_id
            }
            this.getExamTest()
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'ExamTest'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 初始化数据，如果是答题卡传来，直接跳答题卡指定题目
    getFirst () {
      if (this.$route.query.number) {
        this.getExamTest()
      } else {
        this.getRecord()
      }
    },
    // 验证是否需要登录弹窗
    validataToken () {
      let data = {
      }
      return this.$axios({
        method: 'GET',
        url: '/api/app/v1/overdue_user_token',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            return true
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    gotoLogin () {
      if (this.$store.state.uid === '' || this.$store.state.uid === undefined) {
        this.loginShow = true
        return false
      }
      if (this.validataToken()) {
        return false
      }
    },
    showLogin (isShow) {
      this.loginShow = isShow
    }
  }
}
</script>

<style scoped lang="stylus">
  #examtest
    h2.title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #A3A9B7
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      b
        font-size: .48rem
        color: #FF7052
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      .right
        position: absolute
        top: .3rem
        right: .4rem
        display: flex
        justify-content: space-between
        align-items: center
        width: 2.2rem
        height: .62rem
        a
          display: block
          width: .7rem
          line-height: .3rem
          height: 100%
          font-size: .22rem
          color: #333
          text-align: center
          img
            display: block
            width: .24rem
            height: .22rem
            margin: 0 auto .02rem
    h3.type
      padding: 0 .4rem
      margin: .3rem 0
      font-size: .48rem
      color: #050505
      font-weight: 600
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
    .question
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      .title
        font-size: .32rem
        color: #333
        text-align: left
        font-weight: 500
      .choice
        dl
          display: flex
          justify-content: space-between
          align-items: center
          margin-top: .4rem
          dt
            display: block
            width: .64rem
            height: .64rem
            i
              display: block
              width: .64rem
              height: .64rem
              line-height: .64rem
              border: .02rem solid #ccc
              font-size: .32rem
              color: #ccc
              text-align: center
              -webkit-box-sizing: border-box
              -moz-box-sizing: border-box
              box-sizing: border-box
              -webkit-border-radius: 50%
              -moz-border-radius: 50%
              border-radius: 50%
            input
              display: none
            input:checked + i
              border-color: #1E81F2
              background-color: #1E81F2
              color: #fff
          dd
            width: 5.8rem
            font-size: .3rem
            color: #666
      .short
        margin-top: .2rem
        textarea
          width: 100%
          border: .02rem solid #ccc
    .question + hr
      width: 6.7rem
      height: .02rem
      background-color: #CFD1D4
      border: none
      margin: .6rem auto 0
    .analysis
      padding: 0 .4rem
      margin-top: .38rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h4
        font-size: .28rem
        color: #FF7052
        text-align: left
    .fix-valid
      height: 1rem
    .bottom
      position: fixed
      bottom: 0
      left: 50%
      display: flex
      justify-contnet: space-between
      align-items: center
      width: 7.5rem
      height: .98rem
      background-color: #F9F9F9
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
      a
        display: block
        width: 50%
        font-size: .22rem
        color: #5E5E5E
        text-align: center
        img
          display: block
          width: .46rem
          height: .24rem
          margin: 0 auto
        &:nth-of-type(2) img
          width: .32rem
          height: .32rem
        &:nth-of-type(3) img
          width: .34rem
          height: .34rem
        &:nth-of-type(4) img
          width: .36rem
          height: .34rem
  .v-touch
    touch-action: pan-y!important;
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamTest.vue